import { connect } from 'react-redux';
import { Cancellation } from './Cancellation';

const mapStateToProps = (state) => ({
  consumer: state.calendar.inlineClientForm,
});

export const CancellationContainer = connect(mapStateToProps)(Cancellation);
